export default "__VITE_ASSET__COpuaOtN__"